import { render, staticRenderFns } from "./TaxiTransactionPayoutCard.vue?vue&type=template&id=80455a04&scoped=true"
import script from "./TaxiTransactionPayoutCard.vue?vue&type=script&lang=js"
export * from "./TaxiTransactionPayoutCard.vue?vue&type=script&lang=js"
import style0 from "./TaxiTransactionPayoutCard.vue?vue&type=style&index=0&id=80455a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80455a04",
  null
  
)

export default component.exports